import _ from 'lodash'
// import Context from 'common/context'
import { convertMoveResourceVideo } from 'api/Video'
import React, { useCallback, useMemo, useState } from 'react'
import { Button, Card, Grid, Input } from '@material-ui/core'
import MultipleButtonGroups from 'components/MultipleButtonGroups'
import { ShorthandToCountryAndLanguage } from 'common/enum'

export default function (props) {
  // const { handleNotification } = Context._currentValue
  const [payload, setPayload] = useState({})
  const [resourceIds, setResourceIds] = useState([])
  const types = [{ label: 'video', value: 'video' }, { label: 'audio', value: 'audio' }]

  const handleConvert = useCallback(async () => {
    const res = await convertMoveResourceVideo({ resourceIds: resourceIds.split(','), types: payload.types, languages: ShorthandToCountryAndLanguage.filter(l => payload.languages.includes(l.value)) })
    // if (res.fileNotFound.length > 0) handleNotification('info', `some video files not found: ${res.fileNotFound.join(',')}`)
  }, [payload, resourceIds])

  const isBtnDisabled = useMemo(() => {
    return  [resourceIds, payload.languages, payload.types].some(v => _.isEmpty(v))
  }, [payload, resourceIds])

  const handlePayloadChange = useCallback((key, val) => {
    setPayload({ ...payload, [key]: val })
  }, [payload])

  function truncateBlankSpace (event) {
    return event.target.value.replace(/[^\d|,]/g, '')
  }

  return (
    <div className={'root'}>
      <Card className={'form-container'}>
        <Grid container spacing={4}>
          <Grid item xs={12} className='text-align-left'>
            <h3>STEP1: Convert Videos & Audios to M3U8</h3>
          </Grid>

          <Grid container item xs={12}>
            <Grid container item xs={2} alignItems='flex-start'>
              <MultipleButtonGroups name='types' value={payload.types} onChange={handlePayloadChange} options={types} />
            </Grid>
            <Grid container item xs={10} alignItems='flex-start'>
              <MultipleButtonGroups name='languages' value={payload.languages} onChange={handlePayloadChange} options={ShorthandToCountryAndLanguage} />
            </Grid>
          </Grid>

          <Grid item xs={6}>
            <Input name={'ids'} value={resourceIds} onChange={(event) => setResourceIds(truncateBlankSpace(event))} placeholder={'move resource ids (e.g. 1,2,3)'} className={'full-width'} />
          </Grid>
          <Grid item xs={6}/>

          <Grid item xs={12} className='text-align-left'>
            <Button color='primary' variant='contained' onClick={handleConvert} disabled={isBtnDisabled}> CONVERT </Button>
          </Grid>
        </Grid>
      </Card>
    </div>
  )
}